import React from "react";
import MaterialTable from "material-table";

export default function DataTable(props) {
  const {
    columns,
    data,
    title,
    search,
    grouping,
    exportButton,
    paging,
    selection,
    sorting,
    editable,
    actions,
    detailPanel
  } = props;

  return (
    <MaterialTable
      style={{ width: "100%" }}
      title={title}
      columns={columns}
      data={data}
      options={{
        search: search,
        grouping: grouping,
        exportButton: exportButton,
        actionsColumnIndex: -1,
        // paging: paging,
        selection: selection,
        sorting: sorting,
        paging: true,
        pageSize: 10,       // make initial page size
        emptyRowsWhenPaging: false,   // To avoid of having empty rows
        // pageSizeOptions: [6, 12, 20, 50],    // rows selection options
      }}
      editable={editable}
      actions={actions}
      detailPanel={detailPanel}
    />
  );
}
